import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './SkipToMainContent.module.scss';

/**
 * Keyboard "skip to main content" link (WCAG 2.4.1). Visually hidden until it
 * receives focus — the first Tab on any page reveals it — letting keyboard and
 * screen-reader users jump past the promo banner and nav straight to
 * <main id="main-content">.
 */
export default function SkipToMainContent() {
  const { t } = useTranslation();

  return (
    <a href="#main-content" className={styles.skipLink}>
      {t('skip_to_main_content')}
    </a>
  );
}
